// Missing several props and methods from core implementation

import React from 'react';
import { connect } from 'react-redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { PrimaryContentAdvisoryEditor } from '@bibliocommons/shared-ugc-editors';
import { currentUserSelector } from '../../selectors/AuthSelector';

class PrimaryContentAdvisoryEditorContainer extends BcReactComponent {
  constructor(props) {
    super(props);

    const { advisories, advisoryBody, user, bibId, domain, metadataId } = props;
    this.state = {
      characterLimit: 4000,
      advisories: advisories || [],
      advisoryType: null,
      advisoryBody,
      initializingStatus: {
        status: 'success',
        localeKey: null
      },
      user,
      bibId,
      domain,
      metadataId
    };
    this.bindAll('handleAdvisoryTypeChange', 'handleAdvisoryBodyChange', 'handleCancel', 'handleSubmit');
  }

  handleAdvisoryTypeChange(value) {
    this.setState({
      ...this.state,
      advisoryType: value
    });
  }

  handleAdvisoryBodyChange(value) {
    this.setState({
      ...this.state,
      advisoryBody: value
    });
  }

  handleCancel() {
    this.setState({
      ...this.state,
      advisoryType: null,
      advisoryBody: ''
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({
      ...this.state,
      pending: true
    });

    window.setTimeout(() => {
      this.setState({
        ...this.state,
        advisories: [
          ...this.state.advisories,
          {
            type: this.state.advisoryType,
            content: this.state.advisoryBody,
            userContentId: 567365434567
          }
        ],
        advisoryType: null,
        advisoryBody: '',
        pending: false,
        status: 'success'
      });
    }, 1000);
    window.setTimeout(() => {
      this.setState({
        ...this.state,
        status: ''
      });
    }, 2000);
  }

  static handleLogin(e) {
    e.preventDefault();
  }

  render() {
    return (
      <PrimaryContentAdvisoryEditor
        {...this.state}
        handleSubmit={this.handleSubmit}
        handleLogin={this.handleLogin}
        handleCancel={this.handleCancel}
        handleAdvisoryBodyChange={this.handleAdvisoryBodyChange}
        handleAdvisoryTypeChange={this.handleAdvisoryTypeChange} />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const user = currentUserSelector(state);
  const editorUser = user ? {
    loggedIn: true,
    id: user.id,
    // idHash: '',
    allowFreeText: true
  } : { loggedIn: false };

  return {
    user: editorUser,
    bibId: ownProps.bibId,
    domain: state.getIn('library', 'domain'),
    metadataId: ownProps.metadataId
  };
};

export default connect(mapStateToProps)(PrimaryContentAdvisoryEditorContainer);



// WEBPACK FOOTER //
// ./app/containers/UGCTestContainers/PrimaryContentAdvisoryEditorContainer.jsx